import "core-js/modules/es.object.assign.js";
// @ts-ignore
import { formatInteger } from "@utils/NumberUtils";
// @ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
// @ts-ignore
import { showAddFavoritesIcon, showRemoveFavoritesIcons } from "@utils/favoriteUtils";
// @ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { ShareIcon } from "@vueEntry/SvgIcons/ShareIcon";
import { HeartIcon } from "@vueEntry/SvgIcons/HeartIcon";
import { PhotoIcon } from "@vueEntry/SvgIcons/PhotoIcon";
import { MapIcon } from "@vueEntry/SvgIcons/MapIcon";
import { PlanIcon } from "@vueEntry/SvgIcons/PlanIcon";
import { VideoIcon } from "@vueEntry/SvgIcons/VideoIcon";
import { TourIcon } from "@vueEntry/SvgIcons/TourIcon";
import { StreetviewIcon } from "@vueEntry/SvgIcons/StreetviewIcon";
//@ts-ignore
import SwiperCarousel from "@vueEntry/SwiperCarousel.vue";
import { mapActions, mapState } from "pinia";
import { defineComponent } from "vue";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
import { useLoggedUserStore } from "@store/LoggedUserStore";
import { getImageFormat, transformReImages } from "@utils/ImageUtils";
//@ts-ignore
import { IMAGE_FORMATS } from "@customTypes/ImageFormatsEnum";
import { useMetadataStore } from "@wkWebSrc/js/store";
import { useBreakpoints } from "@wkComposables/useBreakpoints";
var TAB;
(function (TAB) {
  TAB[TAB["PHOTO_GALLERY"] = 1] = "PHOTO_GALLERY";
  TAB[TAB["PLANIMETRY"] = 2] = "PLANIMETRY";
  TAB[TAB["STREETVIEW"] = 3] = "STREETVIEW";
  TAB[TAB["VIDEO"] = 4] = "VIDEO";
  TAB[TAB["TOUR"] = 5] = "TOUR";
  TAB[TAB["MAP"] = 6] = "MAP";
})(TAB || (TAB = {}));
/*
  N.B: In order to work properly, the gallery wrapper must have a fixed height.
        In fact, if we check the details page, we can noticed that there is a fixed height of 312px from lg breakpoint on.
*/
export default defineComponent({
  name: "REGallery",
  components: {
    SwiperCarousel,
    BaseIcon,
    BaseButton,
    ShareIcon,
    HeartIcon,
    PhotoIcon,
    MapIcon,
    PlanIcon,
    VideoIcon,
    TourIcon,
    StreetviewIcon
  },
  props: {
    images: {
      type: Array,
      required: true
    },
    planimetries: {
      type: Array,
      default: () => []
    },
    galleryClasses: {
      type: String,
      default: ""
    }
  },
  emits: ["open-share-modal", "open-login-modal", "open-request-attachments-modal"],
  setup() {
    var {
      isDesktopMode
    } = useBreakpoints();
    return {
      isDesktopMode
    };
  },
  data() {
    return {
      currentImage: 0,
      currentPlanimetry: 0,
      titleTab: "",
      fullscreen: false,
      planimetriesFullscreen: false,
      videoFullscreen: false,
      tourFullscreen: false,
      mapFullscreen: false,
      streetViewFullscreen: false,
      realEstate: null,
      parsedImages: [],
      parsedPlanimetries: []
    };
  },
  computed: Object.assign(Object.assign({
    IMAGE_FORMATS() {
      return IMAGE_FORMATS;
    },
    firstFourImages() {
      return this.images.length ? this.images.slice(1, 5) : this.planimetries.slice(1, 5);
    },
    tab() {
      return TAB;
    },
    showFullscreenGallery() {
      return !!(this.fullscreen && this.images.length) || !!(this.planimetriesFullscreen && this.planimetries.length);
    },
    cdn() {
      return window["_cdn"];
    },
    videoUrl() {
      return window["_videoUrl"];
    },
    tourUrl() {
      return window["_tourUrl"];
    },
    mapUrl() {
      return window["_mapUrl"];
    },
    shareUrl() {
      return window["_shareUrl"];
    },
    favUrl() {
      return window["_favUrl"];
    },
    streetView() {
      return window["_streetView"];
    },
    canonicalURL() {
      return window["_canonicalURL"];
    },
    isAuction() {
      return window["_realEstateMiniItem"]["auction"];
    },
    title() {
      if (!this.realEstate) return "";
      return [this.realEstate.typologyName, this.realEstate.address, this.realEstate.cityName].filter(s => !!s).join(", ");
    },
    labels() {
      return window["_labels"];
    },
    displayPrice() {
      var _a, _b, _c;
      if (!((_a = this.realEstate) === null || _a === void 0 ? void 0 : _a.reservedPrice)) {
        return "&euro;" + " " + formatInteger(((_b = this.realEstate) === null || _b === void 0 ? void 0 : _b.rent) && !this.realEstate.sale ? this.realEstate.priceRent : (_c = this.realEstate) === null || _c === void 0 ? void 0 : _c.price);
      } else {
        //@ts-ignore
        return this.labels.reservedPrice;
      }
    },
    isREInFavorites() {
      var _a;
      //@ts-ignore
      return this.getFavoriteById((_a = this.realEstate) === null || _a === void 0 ? void 0 : _a.id) >= 0;
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(useMetadataStore, ["pageName", "location"])),
  created() {
    this.realEstate = JSON.parse(window["_serializedRealEstateBean"]);
    setTimeout(() => {
      this.parsedImages = transformReImages(this.images, [IMAGE_FORMATS.INITIAL]);
      this.parsedPlanimetries = transformReImages(this.planimetries, [IMAGE_FORMATS.INITIAL]);
    });
  },
  mounted() {
    this.$refs.root.setAttribute("gallery-mounted", "true");
    window.addEventListener("popstate", event => {
      switch (event.state) {
        case TAB.PHOTO_GALLERY:
          this.openFullscreen();
          break;
        case TAB.PLANIMETRY:
          this.openPlanimetries();
          break;
        case TAB.STREETVIEW:
          this.openStreetView();
          break;
        case TAB.VIDEO:
          this.openVideo();
          break;
        case TAB.TOUR:
          this.openTour();
          break;
        case TAB.MAP:
          this.openMap();
          break;
        default:
          this.closeFullscreen();
      }
    });
    window.addEventListener("keydown", event => {
      if (event.key === "Escape") {
        this.closeFullscreen();
      }
    });
  },
  methods: Object.assign(Object.assign({
    getImageFormat,
    transformReImages,
    setFavoritesIcon() {
      var hover = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var white = "#fff";
      var blue = "#2b5dff";
      if (hover) return this.isREInFavorites ? {
        "fill-color": white,
        "stroke-color": white
      } : {
        "stroke-color": white
      };else return this.isREInFavorites ? {
        "fill-color": blue,
        "stroke-color": blue
      } : {
        "stroke-color": blue
      };
    },
    normalizeImages(imagesToNormalize) {
      return imagesToNormalize.map(imgToNormalize => {
        var images = imgToNormalize.images;
        imgToNormalize.width = 390;
        imgToNormalize.height = 290;
        if ((images === null || images === void 0 ? void 0 : images.length) > 3) images = imgToNormalize.images.slice(2, 5);else images[0] = images[1];
        imgToNormalize.images = images;
        return imgToNormalize;
      });
    },
    /* Opens the full-screen swiper and, optionally, sets the starting image index of the image array */
    openFullscreen() {
      this.setLocation("Galleria");
      if (!this.images.length) {
        this.openPlanimetries();
        return;
      }
      this.fullscreen = true;
      this.planimetriesFullscreen = false;
      this.videoFullscreen = false;
      this.tourFullscreen = false;
      this.mapFullscreen = false;
      this.streetViewFullscreen = false;
    },
    openPlanimetries() {
      this.fullscreen = false;
      this.planimetriesFullscreen = true;
      this.videoFullscreen = false;
      this.tourFullscreen = false;
      this.mapFullscreen = false;
      this.streetViewFullscreen = false;
    },
    openStreetView() {
      this.fullscreen = false;
      this.planimetriesFullscreen = false;
      this.videoFullscreen = false;
      this.tourFullscreen = false;
      this.mapFullscreen = false;
      this.streetViewFullscreen = true;
    },
    openVideo() {
      this.fullscreen = false;
      this.planimetriesFullscreen = false;
      this.videoFullscreen = true;
      this.tourFullscreen = false;
      this.mapFullscreen = false;
      this.streetViewFullscreen = false;
    },
    openTour() {
      this.planimetriesFullscreen = false;
      this.fullscreen = false;
      this.videoFullscreen = false;
      this.tourFullscreen = true;
      this.mapFullscreen = false;
      this.streetViewFullscreen = false;
    },
    openMap() {
      this.planimetriesFullscreen = false;
      this.fullscreen = false;
      this.videoFullscreen = false;
      this.tourFullscreen = false;
      this.mapFullscreen = true;
      this.streetViewFullscreen = false;
    },
    closeFullscreen() {
      this.setLocation("");
      this.planimetriesFullscreen = false;
      this.fullscreen = false;
      this.videoFullscreen = false;
      this.tourFullscreen = false;
      this.mapFullscreen = false;
      this.streetViewFullscreen = false;
      this.$refs.detailsCarousel.moveTo(this.currentImage);
    },
    /* Sets the initial index of the image array that will be shown in the full-screen splide  */
    goToSlide(index) {
      this.currentImage = index;
    },
    openShareModal() {
      this.$emit("open-share-modal", {
        url: this.shareUrl,
        title: "",
        location: "".concat(this.pageName, " - ").concat(this.location),
        eventName: "real_estate_share"
      });
    },
    onFavBtnClick(id) {
      if (!this.isREInFavorites) this.handleAddFavorite(id);else this.handleRemoveFavorite(id);
    },
    handleAddFavorite(id) {
      if (!this.isUserLogged) this.$emit("open-login-modal");else this.addFavorite(id).then(() => {
        showRemoveFavoritesIcons(id);
      });
    },
    handleRemoveFavorite(id) {
      this.removeFavorite(id).then(() => {
        showAddFavoritesIcon(id);
      });
    }
  }, mapActions(usePublicUserMenuStore, ["getFavoriteById", "addFavorite", "removeFavorite"])), mapActions(useMetadataStore, ["setLocation"]))
});